import { Component, EventEmitter, OnChanges } from '@angular/core';
import { filter, first } from 'rxjs/operators';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { ModalSize } from '../../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { CustomerIndividualBiometric } from '../../models/customer-individual-biometric.model';
import { CustomerIdentificationType } from '../../models/enums/customer-identification-type.enum';
import { CustomerType } from '../../models/enums/customer-type.enum';
import { CustomerManageService } from '../../shared/customer-manage.service';
import { CustomerDetailsContext, CustomerDetailsModalComponent } from './individual-customer-details-modal.component';

@Component({
    selector: 'individual-customer-details',
    templateUrl: './individual-customer-details.html',
    inputs: ['customerNumber', 'details', 'canEdit'],
    outputs: ['deceasedChanged', 'editedDetailsEvent', 'customerStatusTypeIdChanged']
})
export class IndividualCustomerDetailsComponent extends BaseComponent implements OnChanges {
    public deceasedChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    public details: any[];
    public customerNumber: number;
    public individualDetails: CustomerIndividualBiometric;
    public canEdit: boolean;

    private customerTypes = new CustomerType();
    private identificationTypes = new CustomerIdentificationType();
    private CUSTOMER_IDENTIFICATION_TYPE_SSN = 5;

    public editedDetailsEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
    public customerStatusTypeIdChanged: EventEmitter<number> = new EventEmitter<number>();

    constructor(
        public modalService: MvdModalService,
        private service: CustomerManageService) {
        super();
    }

    public ngOnInit() {}

    public ngOnChanges() {
        if ((this.details === undefined || this.details == null) && this.customerNumber != null) {
            this.getDetails();
        }
    }

    public getDetails = async (): Promise<void> => {
        let ssn: string;
        const identifications = await this.service.getCustomerIdentifications(this.customerNumber).pipe(first()).toPromise();
        const ssnIdent = identifications.filter(ident => ident.customerIdentificationTypeId == this.identificationTypes.SSN.id);

        if (ssnIdent.length > 0) {
            ssn = ssnIdent[0].customerIdentificationValue;
        }

        this.service.getCustomerBiometrics(this.customerNumber).subscribe(result => {
            this.individualDetails = result;
            this.deceasedChanged.emit(this.individualDetails.deceasedDate != null);
            let age;

            if (this.individualDetails && this.individualDetails.dateOfBirth) {
                age = this.getAge(this.individualDetails.dateOfBirth, this.individualDetails.deceasedDate);
            }

            this.details = [];
            this.details.push({
                'customerType': this.customerTypes.Individual.displayValue,
                'customerNumber': this.individualDetails.customerNumberId,
                'dateOfBirth': this.individualDetails.dateOfBirth,
                'age': age,
                'deceasedDate': this.individualDetails.deceasedDate,
                'ssn': ssn,
                'isBiometricRedacted': this.individualDetails['isBiometricRedacted']
            });
        }, e => {
            this.handleValidationResult(e);
        });
    };

    public getValues = (id: number, types: any): string => {
        if (id != null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    };

    public editDetails = (id: number): void => {
        const data = new CustomerDetailsContext(this.customerNumber);
        this.modalService.open(CustomerDetailsModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(
                r => {
                    this.getDetails();
                    this.editedDetailsEvent.emit();
                    this.customerStatusTypeIdChanged.emit(r);
                }
            );
    };
}
